import { Exclamation2 } from 'baby-design/icons'
import css from './email-preferences-form.style.scss'

export const PhoneNumberVerificationNeeded: React.FC = () => (
  <div className={`alert-warning ${css.verificationContainer}`}>
    <div className="flex">
      <Exclamation2 className="mrm" />
      <span>
        Verification is needed. Follow the instructions in the text message sent
        to the number above.
      </span>
    </div>
  </div>
)
